export default {
	properties: [
		{
			text: 'Empleado',
			key: 'employee_id',
			type: 'search',
			disabled_to_edit: true,
			use_store_models: true,
		},
		{
			text: 'Tipo de Movimiento',
			key: 'production_batch_movement_type_id',
			type: 'select',
			use_store_models: true,
			value: 0,
			disabled_to_edit: true,
		},
		{
			text: 'Desde estado',
			key: 'from_order_production_status_id',
			store: 'order_production_status',
			value: 0,
			type: 'select',
			use_store_models: true,
			disabled_to_edit: true,
		},
		{
			text: 'Hacia estado',
			key: 'to_order_production_status_id',
			store: 'order_production_status',
			value: 0,
			type: 'select',
			use_store_models: true,
			disabled_to_edit: true,
		},
		{
			text: 'Proveedor',
			key: 'provider_id',
			value: 0,
			type: 'select',
			use_store_models: true,
			disabled_to_edit: true,
		},

		{
			text: 'Deposito',
			key: 'address_id',
			type: 'select',
			use_store_models: true,
			select_prop_name: 'street',
			descriptions: [
				'Depostio para descontar el stock de los insumos',
				'Si indica el deposito en ESTE MOVIMIENTO, se utilizara este deposito para restar el stock de TODOS los insumos implicados en este movimiento.',
				'Si no se indica, se utilizara el deposito indicado en la RUTA DE PRODUCCION utilizada para este LOTE.',
				'En caso de no estar indicado el deposito en la ruta de produccion, se utilizara el deposito indicado de forma individual para cada articulo de la lista de insumos.',
			],
			disabled_to_edit: true,
		},
		{
			text: 'Deposito',
			key: 'to_address_id',
			type: 'select',
			store: 'address',
			use_store_models: true,
			select_prop_name: 'street',
			descriptions: [
				'Depostio para aumentar con el stock producido',
			],
			disabled_to_edit: true,
			not_show_on_form: true,
		},
		{
			text: 'Cantidad',
			key: 'amount',
			type: 'number',
			disabled_to_edit: true,
		},
		{
			text: 'Notas',
			key: 'notes',
			type: 'textarea',
		},
		{
			text: 'Insumos',
			key: 'article_inputs',
			full_cols: true,
		},
	],
	singular_model_name_spanish: 'Movimiento de Produccion',
	plural_model_name_spanish: 'Movimientos de Produccion',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
	full_reactivity: true,
}